import styled from 'styled-components';
import { motion } from 'framer-motion';
import background from 'assets/images/dashboardBackground.png';

export const Layout = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
`;

export const DashboardLayoutStyled = styled(motion.div)`
  width: 100%;
  background-image: url(${background});
  backdrop-filter: blur(223.3000030517578px);
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  padding: 200px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1440px) {
    padding: 140px 80px 50px;
  }

  @media (max-width: 1000px) {
    padding: 120px 30px 50px;
  }
`;

export const Main = styled.div<{ pathname: string }>`
  width: 100%;
  margin: 80px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1450px) {
    margin: 40px auto;
  }

  @media (max-width: 1000px) {
    max-width: calc(100% - 32px);
    padding: 32px 16px 16px 16px;
  }
`;
